document.addEventListener("DOMContentLoaded", function() {
  const tabLinks = document.querySelectorAll(".tab-link");
  const tabRows = document.querySelectorAll(".tab-row");
  const tabsNav = document.querySelector(".tabs-nav");
  const leftBtn = document.querySelector(".tab-scroll-left");
  const rightBtn = document.querySelector(".tab-scroll-right");
  const tabsSection = document.querySelector(".tabs-section");
  const stickyEnabled = tabsSection && tabsSection.classList.contains("sticky-enabled");

  // Prevent parent overflow issues
  tabRows.forEach(row => {
    if (row.parentElement) row.parentElement.style.overflow = "hidden";
  });

  // Function to activate a tab
  function activateTab(tabId) {
    tabLinks.forEach(l => l.classList.remove("active"));
    tabRows.forEach(r => {
      r.classList.remove("active");
      r.style.paddingTop = "";
      r.style.paddingBottom = "";
    });

    const activeLink = document.querySelector(`.tab-link[data-tab="${tabId}"]`);
    if (activeLink) activeLink.classList.add("active");

    const activeRows = document.querySelectorAll(`.tab-row[data-tab="${tabId}"]`);
    activeRows.forEach((r, index) => {
      r.classList.add("active");

      // Add spacing between multiple rows
      if (window.innerWidth > 835 && index !== 0) r.style.paddingTop = "4vw";
    });

    if (window.innerWidth > 835 && activeRows.length > 0) {
      activeRows[0].style.paddingTop = "6vw";
      activeRows[activeRows.length - 1].style.paddingBottom = "6vw";
    }
  }

  // Click handler
  tabsNav?.addEventListener("click", e => {
    const link = e.target.closest(".tab-link");
    if (!link) return;

    const tabId = link.dataset.tab;
    const tabHash = link.dataset.hash;

    activateTab(tabId);

    // Update URL hash without scrolling
    if (tabHash) history.replaceState(null, '', `#${tabHash}`);

    if (stickyEnabled) {
      handleStickyTabs();
      scrollToTabSection();
    }
  });

  // Scroll buttons
  function updateScrollButtons() {
    if (!tabsNav || !leftBtn || !rightBtn) return;
    const maxScroll = tabsNav.scrollWidth - tabsNav.clientWidth;
    leftBtn.style.display = tabsNav.scrollLeft > 0 ? "flex" : "none";
    rightBtn.style.display = tabsNav.scrollLeft < maxScroll ? "flex" : "none";
  }

  if (leftBtn && rightBtn && tabsNav) {
    leftBtn.addEventListener("click", () => tabsNav.scrollBy({ left: -150, behavior: "smooth" }));
    rightBtn.addEventListener("click", () => tabsNav.scrollBy({ left: 150, behavior: "smooth" }));
    tabsNav.addEventListener("scroll", updateScrollButtons);
    window.addEventListener("resize", updateScrollButtons);
    updateScrollButtons();
  }

  // Activate first tab by default
  const firstTab = tabLinks[0]?.dataset.tab;
  if (firstTab) activateTab(firstTab);

  // Activate tab based on URL hash
  const hash = window.location.hash.slice(1);
  if (hash) {
    const link = document.querySelector(`.tab-link[data-hash="${hash}"]`);
    if (link) {
      activateTab(link.dataset.tab);
      if (stickyEnabled) scrollToTabSection();
    }
  }

  // Sticky functionality
  if (stickyEnabled) {
    window.addEventListener('scroll', handleStickyTabs, { passive: true });
    window.addEventListener('resize', handleStickyTabs);
    handleStickyTabs();
  }
});

// Sticky handler
function handleStickyTabs() {
  const tabsSection = document.querySelector('.tabs-section');
  if (!tabsSection || !tabsSection.classList.contains('sticky-enabled')) return;

  const header = document.querySelector('.header-wrapper');
  const headerHeight = header ? header.offsetHeight : 0;
  const tabsSectionParent = tabsSection.parentElement;
  if (!tabsSectionParent) return;

  const activeTabRows = document.querySelectorAll('.tab-row.active');
  if (activeTabRows.length === 0) {
    tabsSectionParent.style.position = '';
    tabsSectionParent.style.zIndex = '';
    tabsSectionParent.style.top = '';
    tabsSection.classList.remove('sticky');
    return;
  }

  const parentRect = tabsSectionParent.getBoundingClientRect();
  const parentTop = parentRect.top;
  const parentHeight = tabsSectionParent.offsetHeight;
  const lastActiveTabRow = activeTabRows[activeTabRows.length - 1];
  const lastActiveTabRowBottom = lastActiveTabRow.getBoundingClientRect().bottom;
  const reachedTop = parentTop <= headerHeight;
  const pastBottom = (lastActiveTabRowBottom - parentHeight) <= headerHeight;

  if (reachedTop && !pastBottom) {
    tabsSectionParent.style.position = 'sticky';
    tabsSectionParent.style.zIndex = '2';
    tabsSectionParent.style.top = `${headerHeight}px`;
    tabsSection.classList.add('sticky');
  } else {
    tabsSectionParent.style.position = '';
    tabsSectionParent.style.zIndex = '';
    tabsSectionParent.style.top = '';
    tabsSection.classList.remove('sticky');
  }
}

// Scroll to tab section
function scrollToTabSection() {
  const tabsSection = document.querySelector('.tabs-section');
  if (!tabsSection) return;

  const tabsSectionParent = tabsSection.parentElement;
  const previousDiv = tabsSectionParent.previousElementSibling;
  const headerHeight = document.querySelector('.header-wrapper')?.offsetHeight || 0;

  // make sure sticky state is calculated with current layout
  handleStickyTabs();

  let targetOffset;

  if (previousDiv) {
    const previousBottom = previousDiv.getBoundingClientRect().bottom + window.scrollY;
    // +1 worked best on your layout to keep the nav condensed/sticky
    targetOffset = previousBottom - headerHeight + 1;
  } else {
    targetOffset = tabsSection.getBoundingClientRect().top + window.scrollY - headerHeight + 1;
  }

  window.scrollTo({
    top: targetOffset,
    behavior: 'smooth',
  });
}
